$(document).ready(function(){

	var checkout_lang = window.location.hostname;

  if ($('div[data-address-field=phone] input').length){
  
  
      //$(".step__footer__continue-btn").prop("disabled",true)
      $("div[data-address-field=phone] input").bind("keypress keyup blur", function (e) {
            
              var keyCode = e.which ? e.which : e.keyCode
            
            if (keyCode != 43 && !(keyCode >= 48 && keyCode <= 57)) {
              return false;
            } else{
             
            }
                
           var phone=$("div[data-address-field=phone] input").val().replace(" ","");
          
       });
      
    }
    
    /*---------------------------------- PhoneValidator ----------------------------------------------*/
    
    
    
    var prevVal = "";
    var err = 0;
    var errIndicative = 0;	

  
  function checkIndicative(){
    if($('#checkout_shipping_address_phone').length > 0){
    	var phoneNumber = $('#checkout_shipping_address_phone').val().replace(/\s/g,'');
    }
    var countryValue = $('#country_info')[0].innerText;
    var inputPhone  = $('#checkout_shipping_address_phone');
    
    
    
    if(countryValue == 'Portugal'){
          console.log("Portugal");

      	if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "5" || phoneNumber[3] != "1"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+351');
                  
                }
      
      
    }else 
      if(countryValue == 'Espanha'){
    
      console.log("Espanha");
      if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "4"){
                  
        //erro de indicativo
        errIndicative = 1;
                  
        inputPhone.val('+34');
                  
      }
      
      
    }else 
      if(countryValue == 'França'){
          console.log("França");

    	if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "3"){
                  
            //erro de indicativo
            errIndicative = 1;
                  
            inputPhone.val('+33');
                  
        }
    }else 
      if(countryValue == 'Inglaterra'){
            console.log("Inglaterra");

      if(phoneNumber[0] != "+" || phoneNumber[1] != "4" || phoneNumber[2] != "4"){

                    //erro de indicativo
                      errIndicative = 1;

                      inputPhone.val('+44');

      }

      
    }else 
      if(countryValue == 'Holanda'){
            console.log("Holanda");

        if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "1"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+31');
                  
       	}
        
        
      }else 
      if(countryValue == 'Alemanha'){
              console.log("Alemanha");

        if(phoneNumber[0] != "+" || phoneNumber[1] != "4" || phoneNumber[2] != "9"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+49');
                  
        }
      
      }else
      if(countryValue == 'Belgium'){
              console.log("Belgium");

        if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "2"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+32');
                  
        }
      
      } else 
      if(countryValue == 'Canada'){
              console.log("Canada");

        if(phoneNumber[0] != "+" || phoneNumber[1] != "1"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+1');
                  
        }
      
      }else 
      if(countryValue == 'Cyprus'){
              console.log("Cyprus");

        if(phoneNumber[0] != "+" || phoneNumber[1] != "3"|| phoneNumber[1] != "5"|| phoneNumber[2] != "7"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+357');
                  
        }
      
      }else
      if(countryValue == 'Denmark'){
              console.log("Cyprus");

        if(phoneNumber[0] != "+" || phoneNumber[1] != "4"|| phoneNumber[2] != "5"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+45');
                  
        }
      
      }else
      if(countryValue == 'Finland'){

        if(phoneNumber[0] != "+" || phoneNumber[1] != "3"|| phoneNumber[2] != "5" || phoneNumber[3] != "8" ){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+358');
                  
        }
      
      }else
      if(countryValue == 'Greece'){

        if(phoneNumber[0] != "+" || phoneNumber[1] != "3"|| phoneNumber[2] != "0"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+30');
                  
        }
      
      }else
      if(countryValue == 'Ireland'){

        if(phoneNumber[0] != "+" || phoneNumber[1] != "3"|| phoneNumber[2] != "5"|| phoneNumber[2] != "3"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+353');
                  
        }
      
      }else
      if(countryValue == 'Italy'){

        if(phoneNumber[0] != "+" || phoneNumber[1] != "3"|| phoneNumber[2] != "9"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+39');
                  
        }
      
      }else
      if(countryValue == 'Luxamburg'){

        if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "5" || phoneNumber[2] != "2"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+352');
                  
        }
      
      }else
      if(countryValue == 'Norway'){

        if(phoneNumber[0] != "+" || phoneNumber[1] != "4" || phoneNumber[2] != "7"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+47');
                  
        }
      
      }else
      if(countryValue == 'Sweden'){

        if(phoneNumber[0] != "+" || phoneNumber[1] != "4" || phoneNumber[2] != "6"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+46');
                  
        }
      
      }else
      if(countryValue == 'Switzerland'){

        if(phoneNumber[0] != "+" || phoneNumber[1] != "4" || phoneNumber[2] != "1"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+41');
                  
        }
      
      }else
      if(countryValue == 'EUA'){

        if(phoneNumber[0] != "+" || phoneNumber[1] != "1"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+1');
                  
        }
      
      }else
      if(countryValue == 'UAE'){

        if(phoneNumber[0] != "+" || phoneNumber[1] != "9" || phoneNumber[2] != "7" || phoneNumber[3] != "1"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+971');
                  
        }
      
      }
      else{
        
              console.log("WW");

      	 if(phoneNumber[0] != "+"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+');
                  
        }
        
      }
  
    
    
    
    
    
    
  }
  
  
    var cellPhoneRules = [
          {
            Country:"Canada",
            AreaCodes:{
            
              0:"403",
              1:"587",
              2:"825",
              3:"780",
              4:"587",
              5:"825",
              6:"604",
              7:"778",
              8:"236",
              9:"250",
              10:"778",
              11:"236",
              12:"204",
              13:"431",
              14:"506",
              15:"709",
              16:"867",
              17:"902",
              18:"867",
              19:"905",
              20:"289",
              21:"365",
              22:"519",
              23:"226",
              24:"548",
              25:"705",
              26:"249",
              27:"613",
              28:"343",
              29:"807",
              30:"416",
              31:"647",
              32:"437",
              33:"902",
              34:"418",
              35:"581",
              36:"450",
              37:"579",
              38:"514",
              39:"438",
              40:"819",
              41:"873",
              42:"306",
              43:"639",
              44:"867"
            
            },
            Length:7
          },
          {
          
            Country:"Belgium",
            AreaCodes:{
            
            },
            Length:9
            
          },
      	  {
            Country:"Cyprus",
            AreaCodes:{},
            Length:8
            
          },
      	  {
            
            Country:"Denmark",
            AreaCodes:{},
            Length:8
            
            
          },
      	  {
            Country:"Finland",
            AreaCodes:{
            
              0:{
              
                OperatorNumber: 4,
                Length:9
                
              },
              1:{
                
                OperatorNumber: 50,
                Length:10              
                
              
              },
              length:2
              
            }
            
          },
      	  {
            Country:"Greece",
            AreaCodes:{
            
              0:{
                
                OperatorNumber: 6,
                Length:10              
                
              
              },
              length:1
            
            }
            
          
          },
      	  {
          
            Country:"Ireland",
            AreaCodes:{
            
              0:{
                
                OperatorNumber: 8,
                Length:9                 
              
              
              },
              length:1
            
            
            
            }
            
          },
      	  {
          
            Country:"Italy",
            AreaCodes:{
            
              0:{
                
                OperatorNumber: 3,
                Length:10 
              
              },
              length:1
            
            }
            
          },
      	  {
          
            Country:"Luxembourg",
            AreaCodes:{
            
              0:{
                
                OperatorNumber: 6,
                Length:9 
              
              },
              length:1
            
            }
            
          },
      	  {
          
            Country:"Norway",
            AreaCodes:{
            
              0:{
                
                OperatorNumber: 4,
                Length:8 
              
              },
              1:{
                
                OperatorNumber: 9,
                Length:8 
              
              },
              length:2
            
            }
            
          },
      	  {
          
            Country:"Sweden",
            AreaCodes:{
            
              0:{
                
                OperatorNumber: 7,
                Length:9 
              
              },
              length:1
            
            }
            
          },
      	  {
          
            Country:"Switzerland",
            AreaCodes:{
            
              0:{
                
                OperatorNumber: 7,
                Length:9 
              
              },
              length:1
            
            }
            
          },
          {          
          
            Country:"EUA",
            AreaCodes:{
            
              0:{
                
                OperatorNumber: 000,
                Length:12 
              
              },
              length:1
            
            }
            
          },
		  {          
          
            Country:"UAE",
            AreaCodes:{
            
              0:{
                
                OperatorNumber: 5,
                Length:9 
              
              },
              length:1
            
            }
            
          }
      ]
  
    function InputChangeListener(){
	
      
          if($('#country_info')[0] == undefined){

			 var countryValue = $('#selectIndicative').val();

            
          }else{
          
            var countryValue = $('#country_info')[0].innerText;
          
          }
          var phoneNumber = $('#checkout_shipping_address_phone').val().replace(/\s/g,'');
          var inputPhone  = $('#checkout_shipping_address_phone');
            if($('#checkout_shipping_address_phone').val() != prevVal){
  
                prevVal = $('#checkout_shipping_address_phone').val();
  
              $('#checkout_shipping_address_phone').change();
              
              if(phoneNumber[5] == undefined){
                 $('#country_phone_validator').css("display", "none");
                 $('#country_phone_validator2').css("display", "none");
                 $('.step__footer__continue-btn').attr("disabled", true);
                 $('.step__footer__continue-btn').css("background-color", "gray");
              }
              
				
              console.log(countryValue);
              if(countryValue == 'Portugal'){
              
                $('#span_warning_indicative').hide();
                if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "5" || phoneNumber[3] != "1"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+351');
                  
                  	console.log("number changed");
                  
                }
                
                phoneNumber = phoneNumber.slice(4);
                //se o 1 é 9 ou 2
                if(phoneNumber[0] == '9'){
                    //primeiro numero esta certo
                    if(phoneNumber[1]== '1' ||phoneNumber[1]== '2' || phoneNumber[1]== '3' || phoneNumber[1]== '6'){
                      	  console.log("all good");
                          var btnSubmit = $('.step__footer__continue-btn');
                          
                          
                          if(phoneNumber[8] != undefined && phoneNumber[9] == undefined ){
                                $('#country_phone_validator').css("display", "none");
                                $('#country_phone_validator2').css("display", "none");
                              $('#country_phone_validator3').css("display", "none");
  
                              err = 0;
                                errIndicative = 0;
                              btnSubmit.attr("disabled", false);
                              btnSubmit.css("background-color", "#000000");
                          }else{
                              //err
                                err =2;
								console.log("err2");

                          }
                       
                    }else{
                        //erro
                      err = 1;
					  console.log("err1");

                    }
                  //nr fixos
                }else 
                  if(phoneNumber[0] == '2'){
                    if(phoneNumber[1] == "1" || phoneNumber[1] == "2"){
                      //ok	
                       var btnSubmit = $('.step__footer__continue-btn');
                       if(phoneNumber[8] != undefined && phoneNumber[9] == undefined ){
                         	  
                              $('#country_phone_validator').css("display", "none");
                                $('#country_phone_validator2').css("display", "none");
                              $('#country_phone_validator3').css("display", "none");
  
                              err = 0;
                                errIndicative = 0;
                              btnSubmit.attr("disabled", false);
                              btnSubmit.css("background-color", "#000000");
                         
                         
                       }else{
                           //err
                           err =2;
                       }
  
                    }else 
                      if(phoneNumber[1] == "3"){
                      
                      if(phoneNumber[2] == "1" || phoneNumber[2] == "2" || phoneNumber[2] == "3" || phoneNumber[2] == "4" || phoneNumber[2] == "5" || 
                         phoneNumber[2] == "6" || phoneNumber[2] == "8" || phoneNumber[2] == "9"){
                        //ok
                        var btnSubmit = $('.step__footer__continue-btn');
                        if(phoneNumber[8] != undefined && phoneNumber[9] == undefined ){
                         
                              $('#country_phone_validator').css("display", "none");
                                $('#country_phone_validator2').css("display", "none");
                              $('#country_phone_validator3').css("display", "none");
  
                              err = 0;
                                errIndicative = 0;
                              btnSubmit.attr("disabled", false);
                              btnSubmit.css("background-color", "#000000");
                         
                       }else{
                           //err
                           err =2;
                       }
                        
                        
                        
                      }else{
                        //erro
                        err = 1;
                      }
                    
                    }else 
                      if(phoneNumber[1] == "4"){
                      
                      if(phoneNumber[2] == "1" || phoneNumber[2] == "2" || phoneNumber[2] == "3" || phoneNumber[2] == "4" || phoneNumber[2] == "5" || phoneNumber[2] == "9"){
                        //ok
                        var btnSubmit = $('.step__footer__continue-btn');
                        if(phoneNumber[8] != undefined && phoneNumber[9] == undefined ){
                         
                              $('#country_phone_validator').css("display", "none");
                               $('#country_phone_validator2').css("display", "none");
                              $('#country_phone_validator3').css("display", "none");
  
                              err = 0;
                                errIndicative = 0;
                              btnSubmit.attr("disabled", false);
                              btnSubmit.css("background-color", "#000000");
							  btnSubmit.css("opacity","1");

                         
                       }else{	
                           //err
                           err =2;
                       }
                        
                      }else{
                          //err
                            err =1;
                      }
                    }else 
                      if(phoneNumber[1] == "5"){
                      if(phoneNumber[2] == "1" || phoneNumber[2] == "2" || phoneNumber[2] == "3" || phoneNumber[2] == "4" || phoneNumber[2] == "5"|| 
                         phoneNumber[2] == "6"|| phoneNumber[2] == "7"|| phoneNumber[2] == "8"|| phoneNumber[2] == "9"){
                        //ok
                        var btnSubmit = $('.step__footer__continue-btn');
                        if(phoneNumber[8] != undefined && phoneNumber[9] == undefined ){
                              err = 0;
                              errIndicative = 0;
                              $('#country_phone_validator').css("display", "none");
                                $('#country_phone_validator2').css("display", "none");
                              $('#country_phone_validator3').css("display", "none");
  
                              
                              btnSubmit.attr("disabled", false);
                              btnSubmit.css("background-color", "#000000");
							  btnSubmit.css("opacity","1");
                         
                       }else{	
                           //err
                           err =2;
                       }
                        
                      }else{
                          //err 
                        err =1;
                      }
                      
                    
                    }else 
                      if(phoneNumber[1] == "6"){
                      
                      if(phoneNumber[2] == "1" || phoneNumber[2] == "2" || phoneNumber[2] == "3" || phoneNumber[2] == "5"|| phoneNumber[2] == "6"|| phoneNumber[2] == "8"|| phoneNumber[2] == "9"){
                          //ok
                          var btnSubmit = $('.step__footer__continue-btn');
                          if(phoneNumber[8] != undefined && phoneNumber[9] == undefined ){
  
                                $('#country_phone_validator').css("display", "none");
                                $('#country_phone_validator2').css("display", "none");
                                $('#country_phone_validator3').css("display", "none");
  
                                err = 0;
                                errIndicative = 0;
                                btnSubmit.attr("disabled", false);
                                btnSubmit.css("background-color", "#000000");
								btnSubmit.css("opacity","1");

  
                         }else{	
                             //err
                             err =2;
                         }
  
                        }else{
                            //err
                            err =1;
                        }
      
                      
                    }else 
                      if(phoneNumber[1] == "7"){
                      
                       if(phoneNumber[2] == "1" || phoneNumber[2] == "2" || phoneNumber[2] == "3" || phoneNumber[2] == "4" || phoneNumber[2] == "5"|| phoneNumber[2] == "6"|| phoneNumber[2] == "8"|| phoneNumber[2] == "9"){
                         //ok
                            var btnSubmit = $('.step__footer__continue-btn');
                            if(phoneNumber[8] != undefined && phoneNumber[9] == undefined ){
  
                                  $('#country_phone_validator').css("display", "none");
                                  $('#country_phone_validator2').css("display", "none");
                                  $('#country_phone_validator3').css("display", "none");
  
                                  err = 0;
                                  errIndicative = 0;
                                  btnSubmit.attr("disabled", false);
                                  btnSubmit.css("background-color", "#000000");
   	        					  btnSubmit.css("opacity","1");

  
                           }else{	
                               //err
                               err =2;
                           }
  
                          }else{
                              //err
                              err =1;
                          }
      
                    }else 
                      if(phoneNumber[1] == "8"){
                    
                      if(phoneNumber[2] == "1" || phoneNumber[2] == "2" || phoneNumber[2] == "3" || phoneNumber[2] == "4" || phoneNumber[2] == "5"|| phoneNumber[2] == "6"|| phoneNumber[2] == "8"|| phoneNumber[2] == "9"){
                         //ok
                            var btnSubmit = $('.step__footer__continue-btn');
                            if(phoneNumber[8] != undefined && phoneNumber[9] == undefined ){
  
                                  $('#country_phone_validator').css("display", "none");
                                  $('#country_phone_validator2').css("display", "none");
                                  $('#country_phone_validator3').css("display", "none");
  
                                  err = 0;
                                  errIndicative = 0;
                                  btnSubmit.attr("disabled", false);
                                  btnSubmit.css("background-color", "#000000");
	  		                      btnSubmit.css("opacity","1");

  
                           }else{	
                               //err
                               err =2;
                           }
  
                          }else{
                              //err
                              err =1;
                          }
                      
                    }else{
                    //erro
                  err = 1;
                }
                  } else{ 
                  	//err
                    err =1;
                  } }else 
              if(countryValue == 'Espanha' | countryValue == 'Spain'){
                
                 $('#span_warning_indicative').hide();
                 if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "4"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                    console.log("erro de indicativo "+countryValue);

                    inputPhone.val('+34');
                  
                }
                
                  
                    phoneNumber = phoneNumber.slice(3);
  
  
                  if(phoneNumber[0] == '6' || phoneNumber[0] == '7' && phoneNumber[1] != '0'  ){
                    //primeiro numero esta certo
                         
                        if(phoneNumber[8] != undefined && phoneNumber[9] == undefined){
                            var btnSubmit = $('.step__footer__continue-btn');
                        
                            $('#country_phone_validator').css("display", "none");
                            $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                            errIndicative= 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
                          btnSubmit.css("opacity","1");
                          
                      }else{
                            //erro
                          err = 2;
                      }
                    //nr fixos
                  }else 
                  if(phoneNumber[0] == '9'){
                    
                    if(phoneNumber[1] == '1' || phoneNumber[1] == '5' || phoneNumber[1] == '6'){
                        
                       if(phoneNumber[2] == "0" || phoneNumber[2] == "1" || phoneNumber[2] == "2" || phoneNumber[2] == "3" || phoneNumber[2] == "4" || 
                          phoneNumber[2] == "5" || phoneNumber[2] == "6" || phoneNumber[2] == "7" || phoneNumber[2] == "8" || phoneNumber[2] == "9"){
                            
                         if(phoneNumber[8] != undefined && phoneNumber[9] == undefined){
                            var btnSubmit = $('.step__footer__continue-btn');
                        
                            $('#country_phone_validator').css("display", "none");
                            $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                            errIndicative= 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");

                      }else{
                            //erro
                          err = 2;
                      }
                         }else{
                            //err
                          err = 1;
                         }
                    }else 
                    if(phoneNumber[1] == '2' || phoneNumber[1] == '3' || phoneNumber[1] == '8'){
                      
                       if(phoneNumber[2] == "0" || phoneNumber[2] == "1" || phoneNumber[2] == "2" || phoneNumber[2] == "3" || phoneNumber[2] == "4" || 
                          phoneNumber[2] == "5" || phoneNumber[2] == "6" || phoneNumber[2] == "7" || phoneNumber[2] == "8"){
                            
                           if(phoneNumber[8] != undefined && phoneNumber[9] == undefined){
                              var btnSubmit = $('.step__footer__continue-btn');

                              $('#country_phone_validator').css("display", "none");
                              $('#country_phone_validator2').css("display", "none");
                            $('#country_phone_validator3').css("display", "none");
                            err = 0;
                              errIndicative= 0;
                            btnSubmit.attr("disabled", false);
                            btnSubmit.css("background-color", "#000000");
                            btnSubmit.css("opacity","1");

                             
                              }else{
                                    //erro
                                  err = 2;
                              }
                         }else{
                            //err
                          err = 1;
                         }
                    }else 
                    if(phoneNumber[1] == '4' ||phoneNumber[1] == '7'){
                      
                      
                      if(phoneNumber[2] == "9" || phoneNumber[2] == "1" || phoneNumber[2] == "2" || phoneNumber[2] == "3" || phoneNumber[2] == "4" || 
                         phoneNumber[2] == "5" || phoneNumber[2] == "6" || phoneNumber[2] == "7" || phoneNumber[2] == "8"){
  
                           if(phoneNumber[8] != undefined && phoneNumber[9] == undefined){
                            var btnSubmit = $('.step__footer__continue-btn');
  
                            $('#country_phone_validator').css("display", "none");
                            $('#country_phone_validator2').css("display", "none");
                            $('#country_phone_validator3').css("display", "none");
                            err = 0;
                            errIndicative= 0;
                            btnSubmit.attr("disabled", false);
                            btnSubmit.css("background-color", "#000000");
                            btnSubmit.css("opacity","1");

                        }else{
                            //erro
                            err = 2;
                        }
                         }else{
                            //err
                            err = 1;
                         }
                    }else{
                      //err
                      err = 1;
                    
                   }
                 
                
                  }else{
                  	//err
                    err = 1;
                  }
              }else 
              if(countryValue == 'França'  | countryValue == 'França'){
                
                 $('#span_warning_indicative').hide();
                 if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "3"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+33');
                  
                }
                    phoneNumber =phoneNumber.slice(3);
                
                if(phoneNumber[0] == '6' || phoneNumber[0] == '7'){
                   //primeiro numero esta certo
                        if(phoneNumber[8] != undefined && phoneNumber[9] == undefined){
                            var btnSubmit = $('.step__footer__continue-btn');
                        
                            $('#country_phone_validator').css("display", "none");
                            $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                            errIndicative = 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");

                      }else{
                            //erro
                          err = 2;
                        }
  
                }else //nr fixos
                if(phoneNumber[0] == '1' ||phoneNumber[0] == '2' || phoneNumber[0] == '3' || phoneNumber[0] == '4' || phoneNumber[0] == '5'){
                  
              		var numberPhone3 = phoneNumber[0] + phoneNumber[1] + phoneNumber[2];
                  
                  if(numberPhone3 >= '110' && numberPhone3 <= '199' || numberPhone3 >= '210' && numberPhone3 <= '261' || numberPhone3 >= '264' && numberPhone3 <= '268' ||
                     numberPhone3 >= '270' && numberPhone3 <= '299' || numberPhone3 >= '310' && numberPhone3 <= '399' || numberPhone3 >= '410' && numberPhone3 <= '499' ||
                     numberPhone3 >= '516' && numberPhone3 <= '589'){
                    
                        if(phoneNumber[8] != undefined && phoneNumber[9] == undefined){
                            var btnSubmit = $('.step__footer__continue-btn');
                        
                            $('#country_phone_validator').css("display", "none");
                            $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                            errIndicative = 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");

                      }else{
                            //erro
                          err = 2;
                        }
                  }else{
                  	//err
                    err = 1;
                  }
                  
                }else {
                    //err
                  err=1;
                }
                
              }else 
              if(countryValue == 'Inglaterra' | countryValue == 'United Kingdom'){
                
                
                 $('#span_warning_indicative').hide();
                 if(phoneNumber[0] != "+" || phoneNumber[1] != "4" || phoneNumber[2] != "4"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+44');
                  
                }
              
                  phoneNumber = phoneNumber.slice(3);
                  //nr fixos	
                    if(phoneNumber[0] == "0" && phoneNumber[1] == "7" || phoneNumber[0] == "7"){
                          
                      	  console.log(phoneNumber);
                          if(phoneNumber[9] != undefined && phoneNumber[10] == undefined || phoneNumber[10] != undefined && phoneNumber[11] == undefined){
                           console.log("number ok");

                            var btnSubmit = $('.step__footer__continue-btn');
  
                            $('#country_phone_validator').css("display", "none");
                            $('#country_phone_validator2').css("display", "none");
                            $('#country_phone_validator3').css("display", "none");
  
                            err = 0;
                            errIndicative=0;
                            btnSubmit.attr("disabled", false);
                            btnSubmit.css("background-color", "#000000");
							btnSubmit.css("opacity","1");

                          }else{
                              //err
                            err=2;
                          
                          }
                  }else if(phoneNumber[0] == "2" || phoneNumber[1] == "2"){
                    
                    if(phoneNumber[1] == "1" || phoneNumber[2] == "1" || phoneNumber[1] == "2" || phoneNumber[2] == "2" || phoneNumber[1] == "3"|| phoneNumber[2] == "3"|| 
                       phoneNumber[1] == "4"|| phoneNumber[2] == "4"|| phoneNumber[1] == "5"|| phoneNumber[2] == "5"|| phoneNumber[1] == "7"|| phoneNumber[2] == "7" ||
                       phoneNumber[1] == "8"|| phoneNumber[2] == "8" || phoneNumber[1] == "9"|| phoneNumber[2] == "9"){
                            
                      
                      if(phoneNumber[8] != undefined && phoneNumber[9] == undefined){
                            var btnSubmit = $('.step__footer__continue-btn');
  
                            $('#country_phone_validator').css("display", "none");
                            $('#country_phone_validator2').css("display", "none");
                            $('#country_phone_validator3').css("display", "none");
  
                            err = 0;
                            errIndicative=0;
                            btnSubmit.attr("disabled", false);
                            btnSubmit.css("background-color", "#000000");
							btnSubmit.css("opacity","1");

                        
                          }else{
                              //err
                            err=2;
                          
                          }
                      
                    }else{
                      if(phoneNumber[1] == "6" ||phoneNumber[2] == "6"){
                        if(phoneNumber[2] == "2" || phoneNumber[3] == "2"){
                          if(phoneNumber[3] == "4" || phoneNumber[4] == "4"){
                            
                            if(phoneNumber[8] != undefined && phoneNumber[9] == undefined){
                              var btnSubmit = $('.step__footer__continue-btn');
  
                              $('#country_phone_validator').css("display", "none");
                              $('#country_phone_validator2').css("display", "none");
                              $('#country_phone_validator3').css("display", "none");
  
                              err = 0;
                              errIndicative=0;
                              btnSubmit.attr("disabled", false);
                              btnSubmit.css("background-color", "#000000");
							  btnSubmit.css("opacity","1");

                            }else{
                                //err
                              err=2;
  
                            }
                            
                          }else{
                              //err 
                                err = 1;
                          }
                        }else{
                            //err
                          err= 1;
                        }
                      
                      }else{
                          //err
                          err = 1;
                      }
                    }  	
                    
                  }else{
                      //err
                      err = 1;
                  }
  
  
              }else 
	          if(countryValue == 'Holanda'){
               
               $('#span_warning_indicative').hide();
               if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "1"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+31');
                  
                }
                phoneNumber =phoneNumber.slice(3);
              
              if(phoneNumber[0] == "0" && phoneNumber[1] == "6" ||phoneNumber[0] == "6"){
                
                if(phoneNumber[1] == "1" || phoneNumber[1] == "2" || phoneNumber[1] == "3" || phoneNumber[1] == "4" || phoneNumber[1] == "5" || phoneNumber[1] == "8" ||
                   phoneNumber[2] == "1" || phoneNumber[2] == "2" || phoneNumber[2] == "3" || phoneNumber[2] == "4" || phoneNumber[2] == "5" || phoneNumber[2] == "8"){
                  
  
                    if(phoneNumber[8] != undefined && phoneNumber[9] == undefined){
                            var btnSubmit = $('.step__footer__continue-btn');
  
                             $('#country_phone_validator').css("display", "none");
                             $('#country_phone_validator2').css("display", "none");
                             $('#country_phone_validator3').css("display", "none");
  
                             err = 0;
                             errIndicative=0;
                             btnSubmit.attr("disabled", false);
                             btnSubmit.css("background-color", "#000000");
							 btnSubmit.css("opacity","1");

                        }else{
                            //erro
                            err = 2;
                        }
                  
                //nr fixo  
                }else if(phoneNumber[0] == "0" && phoneNumber[1] == "7" || phoneNumber[0] == "7"){
                  
                  
                  if(phoneNumber[8] != undefined && phoneNumber[9] == undefined){
                            var btnSubmit = $('.step__footer__continue-btn');
  
                             $('#country_phone_validator').css("display", "none");
                             $('#country_phone_validator2').css("display", "none");
                             $('#country_phone_validator3').css("display", "none");
  
                             err = 0;
                             errIndicative=0;
                             btnSubmit.attr("disabled", false);
                             btnSubmit.css("background-color", "#000000");
							 btnSubmit.css("opacity","1");
                    
                        }else{
                            //erro
                            err = 2;
                        }
                  
                }else{
                    //err 
                  err =1;
                }
              
             
              }else{
                  //err
                    err = 1;
              }
              }else
              if(countryValue == 'Alemanha'){

              $('#span_warning_indicative').hide();
              if(phoneNumber[0] != "+" || phoneNumber[1] != "4" || phoneNumber[2] != "9"){
                  
                  //erro de indicativo
                    errIndicative = 1;
                  
                    inputPhone.val('+49');
                  
                }
              
              phoneNumber = phoneNumber.slice(3);
              console.log(phoneNumber);
              if(phoneNumber[0] == "0" && phoneNumber[1] == "1" || phoneNumber[0] == "1" ){
                  
                if(phoneNumber[2] == '5'|| phoneNumber[2] == '6'||phoneNumber[2] == '7'){
  		
                    console.log(phoneNumber[8]);
                    console.log(phoneNumber[9]);
                    console.log(phoneNumber[10]);

                    
                    if(phoneNumber[8] != undefined && phoneNumber[9] == undefined || phoneNumber[9] != undefined && phoneNumber[10] == undefined){
                            var btnSubmit = $('.step__footer__continue-btn');
  
                             $('#country_phone_validator').css("display", "none");
                             $('#country_phone_validator2').css("display", "none");
                             $('#country_phone_validator3').css("display", "none");
  
                             err = 0;
                             errIndicative=0;
                             btnSubmit.attr("disabled", false);
                             btnSubmit.css("background-color", "#000000");
                      		 btnSubmit.css("opacity","1");

                      
                        }else{
                            //erro
                            err = 2;
                        }
                }else {
                    //err
                    err =1 ;
                }
                
                //nrs fixos
              }
              
  
              }else
              if(countryValue == 'Belgium'){
				
                console.log(cellPhoneRules);
                $('#span_warning_indicative').hide();
                if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "2"){

                    //erro de indicativo
                      errIndicative = 1;

                      inputPhone.val('+32');

                }

                phoneNumber = phoneNumber.slice(3);

                //ciclo de countries
                for(var i = 0; cellPhoneRules.length > 0; i++){
                  
                  
                  //verifica caso exista o Country no objeto.
                  if(countryValue == cellPhoneRules[i].Country ){
                      
                        if(phoneNumber.length == cellPhoneRules[i].Length){
                        	
                          //all ok
                          
                          var btnSubmit = $('.step__footer__continue-btn');
                        
                            $('#country_phone_validator').css("display", "none");
                            $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                            errIndicative = 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");
                        
                        }

                  
                  		break;
                  }
                
                
                
                }

             
              }else
              if(countryValue == 'Canada'){
				
                console.log(cellPhoneRules);
                $('#span_warning_indicative').hide();
                if(phoneNumber[0] != "+" || phoneNumber[1] != "1"){

                    //erro de indicativo
                      errIndicative = 1;

                      inputPhone.val('+1');

                }

                phoneNumber = phoneNumber.slice(2);

                //ciclo de countries
                for(var i = 0; cellPhoneRules.length > 0; i++){
                  
                  
                  //verifica caso exista o Country no objeto.
                  if(countryValue == cellPhoneRules[i].Country ){
                      
                        if(phoneNumber.length == cellPhoneRules[i].Length){
                        	
                          //all ok
                          
                          var btnSubmit = $('.step__footer__continue-btn');
                        
                            $('#country_phone_validator').css("display", "none");
                            $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                            errIndicative = 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");
                        
                        }

                  
                  		break;
                  }
                
                
                
                }

             
              }else
              if(countryValue == 'Cyprus'){
				
                console.log(cellPhoneRules);
                $('#span_warning_indicative').hide();
                if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "5" ||phoneNumber[3] != "7" ){

                    //erro de indicativo
                      errIndicative = 1;

                      inputPhone.val('+357');

                }

                phoneNumber = phoneNumber.slice(4);

                //ciclo de countries
                for(var i = 0; cellPhoneRules.length > 0; i++){
                  
                  
                  //verifica caso exista o Country no objeto.
                  if(countryValue == cellPhoneRules[i].Country ){
                    
                    
                    if(phoneNumber[0] == "9" || phoneNumber[1] != "0"){
                      
                        if(phoneNumber.length == cellPhoneRules[i].Length){
                        	
                          //all ok
                          
                          var btnSubmit = $('.step__footer__continue-btn');
                        
                            $('#country_phone_validator').css("display", "none");
                            $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                            errIndicative = 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");
                        
                        }
                    }

                  
                  		break;
                  }
                
                
                
                }

             
              }else
              if(countryValue == 'Denmark'){
              
                console.log(cellPhoneRules);
                $('#span_warning_indicative').hide();
                if(phoneNumber[0] != "+" || phoneNumber[1] != "4" || phoneNumber[2] != "5"){

                    //erro de indicativo
                      errIndicative = 1;

                      inputPhone.val('+45');

                }

                phoneNumber = phoneNumber.slice(3);

                //ciclo de countries
                for(var i = 0; cellPhoneRules.length > 0; i++){
                  
                  
                  //verifica caso exista o Country no objeto.
                  if(countryValue == cellPhoneRules[i].Country ){
                      
                    	//regra de comprimento no numero
                        if(phoneNumber.length == cellPhoneRules[i].Length){
                        	
                          //all ok
                          
                          var btnSubmit = $('.step__footer__continue-btn');
                        
                          $('#country_phone_validator').css("display", "none");
                          $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                          errIndicative = 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");
                        
                        }else{
                        
                          err = 2;
                          //inputPhone.val('+45');
                        
                        }

                  
                  		break;
                  }
                
                
                
                }
                
                
              }else
              if(countryValue == 'Finland'){

                $('#span_warning_indicative').hide();
                if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "5" || phoneNumber[3] != "8"){

                    //erro de indicativo
                      errIndicative = 1;

                      inputPhone.val('+358');

                }

                phoneNumber = phoneNumber.slice(4);

                //ciclo de countries
                for(var i = 0; cellPhoneRules.length > 0; i++){
                  
                  
                  //verifica caso exista o Country no objeto.
                  if(countryValue == cellPhoneRules[i].Country ){

                    for(var f= 0 ; f < cellPhoneRules[i].AreaCodes.length; f++){
                      
                      
                    
                      if( phoneNumber[0] == cellPhoneRules[i].AreaCodes[f].OperatorNumber || parseInt("" + phoneNumber[0] + phoneNumber[1]) == cellPhoneRules[i].AreaCodes[f].OperatorNumber ){
                        console.log(phoneNumber[0])	
                        if(phoneNumber.length == cellPhoneRules[i].AreaCodes[f].Length ){
                        
                        
                          //all ok
                          
                          var btnSubmit = $('.step__footer__continue-btn');
                        
                          $('#country_phone_validator').css("display", "none");
                          $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                          errIndicative = 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");
                        
                          break;
                        
                        }else{
                        
                          err = 2;
                          //inputPhone.val('+358');
                        
                        }

                      
                        
                      
                      
                      }else{
                      
                        err = 1;
                        //inputPhone.val('+358');
                        
                      
                      }
                    
                    
                    }
                    
                  
                  		break;
                  }
                
                
                
                }
                
                
              }else
              if(countryValue == 'Greece'){

                $('#span_warning_indicative').hide();
                if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "0"){

                    //erro de indicativo
                      errIndicative = 1;

                      inputPhone.val('+30');

                }

                phoneNumber = phoneNumber.slice(3);

                //ciclo de countries
                for(var i = 0; cellPhoneRules.length > 0; i++){
                  
                  
                  //verifica caso exista o Country no objeto.
                  if(countryValue == cellPhoneRules[i].Country ){

                    for(var f= 0 ; f < cellPhoneRules[i].AreaCodes.length; f++){
                      
                      
                    
                      if( phoneNumber[0] == cellPhoneRules[i].AreaCodes[f].OperatorNumber || parseInt("" + phoneNumber[0] + phoneNumber[1]) == cellPhoneRules[i].AreaCodes[f].OperatorNumber ){
                        console.log(phoneNumber[0])	
                        if(phoneNumber.length == cellPhoneRules[i].AreaCodes[f].Length ){
                        
                        
                          //all ok
                          
                          var btnSubmit = $('.step__footer__continue-btn');
                        
                          $('#country_phone_validator').css("display", "none");
                          $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                          errIndicative = 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");
                        
                          break;
                        
                        }else{
                        
                          err = 2;
                          //inputPhone.val('+358');
                        
                        }

                      
                        
                      
                      
                      }else{
                      
                        err = 1;
                        //inputPhone.val('+358');
                        
                      
                      }
                    
                    
                    }
                    
                  
                  		break;
                  }
                
                
                
                }
                
                
              }else
              if(countryValue == 'Ireland'){

                $('#span_warning_indicative').hide();
                if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "5"|| phoneNumber[3] != "3"){

                    //erro de indicativo
                      errIndicative = 1;

                      inputPhone.val('+353');

                }

                phoneNumber = phoneNumber.slice(4);

                //ciclo de countries
                for(var i = 0; cellPhoneRules.length > 0; i++){
                  
                  
                  //verifica caso exista o Country no objeto.
                  if(countryValue == cellPhoneRules[i].Country ){

                    for(var f= 0 ; f < cellPhoneRules[i].AreaCodes.length; f++){
                      
                      
                    
                      if( phoneNumber[0] == cellPhoneRules[i].AreaCodes[f].OperatorNumber &&  phoneNumber[1] != 0 && phoneNumber[1] != 1 || parseInt("" + phoneNumber[0] + phoneNumber[1]) == cellPhoneRules[i].AreaCodes[f].OperatorNumber  &&  phoneNumber[1] != 0 && phoneNumber[1] != 1  ){
                        if(phoneNumber.length == cellPhoneRules[i].AreaCodes[f].Length ){
                        
                        
                          //all ok
                          
                          var btnSubmit = $('.step__footer__continue-btn');
                        
                          $('#country_phone_validator').css("display", "none");
                          $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                          errIndicative = 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");
                        
                          break;
                        
                        }else{
                        
                          err = 2;
                          //inputPhone.val('+358');
                        
                        }

                      
                        
                      
                      
                      }else{
                      
                        err = 1;
                        //inputPhone.val('+358');
                        
                      
                      }
                    
                    
                    }
                    
                  
                  		break;
                  }
                
                
                
                }
                
                
              }else
              if(countryValue == 'Italy'){
                
                $('#span_warning_indicative').hide();
                if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "9"){

                    //erro de indicativo
                      errIndicative = 1;

                      inputPhone.val('+39');

                }

                phoneNumber = phoneNumber.slice(3);

                //ciclo de countries
                for(var i = 0; cellPhoneRules.length > 0; i++){
                  

                  //verifica caso exista o Country no objeto.
                  if(countryValue == cellPhoneRules[i].Country ){
                  
                    for(var f= 0 ; f < cellPhoneRules[i].AreaCodes.length; f++){
                      
                      console.log(phoneNumber)
                    
                      if( phoneNumber[0] == cellPhoneRules[i].AreaCodes[f].OperatorNumber || parseInt("" + phoneNumber[0] + phoneNumber[1]) == cellPhoneRules[i].AreaCodes[f].OperatorNumber ){
                        if(phoneNumber.length == cellPhoneRules[i].AreaCodes[f].Length ){
                        
                        
                          //all ok
                          
                          var btnSubmit = $('.step__footer__continue-btn');
                        
                          $('#country_phone_validator').css("display", "none");
                          $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                          errIndicative = 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");
                        
                          break;
                        
                        }else{
                        
                          err = 2;
                          //inputPhone.val('+358');
                        
                        }

                      
                        
                      
                      
                      }else{
                      
                        err = 1;
                        //inputPhone.val('+358');
                        
                      
                      }
                    
                    
                    }
                    
                  
                  		break;
                  }
                
                
                
                }
                
                
              }else
              if(countryValue == 'Luxembourg'){
                
                $('#span_warning_indicative').hide();
                if(phoneNumber[0] != "+" || phoneNumber[1] != "3" || phoneNumber[2] != "5"  || phoneNumber[3] != "2"){

                    //erro de indicativo
                      errIndicative = 1;

                      inputPhone.val('+352');

                }

                phoneNumber = phoneNumber.slice(4);

                //ciclo de countries
                for(var i = 0; cellPhoneRules.length > 0; i++){
                  

                  //verifica caso exista o Country no objeto.
                  if(countryValue == cellPhoneRules[i].Country ){
                  
                    for(var f= 0 ; f < cellPhoneRules[i].AreaCodes.length; f++){
                      
                      console.log(phoneNumber)
                    
                      if( phoneNumber[0] == cellPhoneRules[i].AreaCodes[f].OperatorNumber || parseInt("" + phoneNumber[0] + phoneNumber[1]) == cellPhoneRules[i].AreaCodes[f].OperatorNumber ){
                        if(phoneNumber.length == cellPhoneRules[i].AreaCodes[f].Length ){
                        
                        
                          //all ok
                          
                          var btnSubmit = $('.step__footer__continue-btn');
                        
                          $('#country_phone_validator').css("display", "none");
                          $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                          errIndicative = 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");
                        
                          break;
                        
                        }else{
                        
                          err = 2;
                          //inputPhone.val('+358');
                        
                        }

                      
                        
                      
                      
                      }else{
                      
                        err = 1;
                        //inputPhone.val('+358');
                        
                      
                      }
                    
                    
                    }
                    
                  
                  		break;
                  }
                
                
                
                }
                
                
              }else
              if(countryValue == 'Norway'){
                
                $('#span_warning_indicative').hide();
                if(phoneNumber[0] != "+" || phoneNumber[1] != "4" || phoneNumber[2] != "7"){

                    //erro de indicativo
                      errIndicative = 1;

                      inputPhone.val('+47');

                }

                phoneNumber = phoneNumber.slice(3);

                //ciclo de countries
                for(var i = 0; cellPhoneRules.length > 0; i++){
                  

                  //verifica caso exista o Country no objeto.
                  if(countryValue == cellPhoneRules[i].Country ){
                  
                    for(var f= 0 ; f < cellPhoneRules[i].AreaCodes.length; f++){
                      
                      console.log(phoneNumber)
                    
                      if( phoneNumber[0] == cellPhoneRules[i].AreaCodes[f].OperatorNumber || parseInt("" + phoneNumber[0] + phoneNumber[1]) == cellPhoneRules[i].AreaCodes[f].OperatorNumber ){
                        if(phoneNumber.length == cellPhoneRules[i].AreaCodes[f].Length ){
                        
                        
                          //all ok
                          
                          var btnSubmit = $('.step__footer__continue-btn');
                        
                          $('#country_phone_validator').css("display", "none");
                          $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                          errIndicative = 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");
                        
                          break;
                        
                        }else{
                        
                          err = 2;
                          //inputPhone.val('+358');
                        
                        }

                      
                        
                      
                      
                      }else{
                      
                        err = 1;
                        //inputPhone.val('+358');
                        
                      
                      }
                    
                    
                    }
                    
                  
                  		break;
                  }
                
                
                
                }
                
                
              }else
              if(countryValue == 'Sweden'){
                
                $('#span_warning_indicative').hide();
                if(phoneNumber[0] != "+" || phoneNumber[1] != "4" || phoneNumber[2] != "6"){

                    //erro de indicativo
                      errIndicative = 1;

                      inputPhone.val('+46');

                }

                phoneNumber = phoneNumber.slice(3);

                //ciclo de countries
                for(var i = 0; cellPhoneRules.length > 0; i++){
                  

                  //verifica caso exista o Country no objeto.
                  if(countryValue == cellPhoneRules[i].Country ){
                  
                    for(var f= 0 ; f < cellPhoneRules[i].AreaCodes.length; f++){
                      
                      console.log(phoneNumber)
                    
                      if( phoneNumber[0] == cellPhoneRules[i].AreaCodes[f].OperatorNumber || parseInt("" + phoneNumber[0] + phoneNumber[1]) == cellPhoneRules[i].AreaCodes[f].OperatorNumber ){
                        if(phoneNumber.length == cellPhoneRules[i].AreaCodes[f].Length ){
                        
                        
                          //all ok
                          
                          var btnSubmit = $('.step__footer__continue-btn');
                        
                          $('#country_phone_validator').css("display", "none");
                          $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                          errIndicative = 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");
                        
                          break;
                        
                        }else{
                        
                          err = 2;
                          //inputPhone.val('+358');
                        
                        }

                      
                        
                      
                      
                      }else{
                      
                        err = 1;
                        //inputPhone.val('+358');
                        
                      
                      }
                    
                    
                    }
                    
                  
                  		break;
                  }
                
                
                
                }
                
                
              }else
              if(countryValue == 'Switzerland'){
                
                $('#span_warning_indicative').hide();
                if(phoneNumber[0] != "+" || phoneNumber[1] != "4" || phoneNumber[2] != "1"){

                    //erro de indicativo
                      errIndicative = 1;

                      inputPhone.val('+41');

                }

                phoneNumber = phoneNumber.slice(3);

                //ciclo de countries
                for(var i = 0; cellPhoneRules.length > 0; i++){
                  

                  //verifica caso exista o Country no objeto.
                  if(countryValue == cellPhoneRules[i].Country ){
                  
                    for(var f= 0 ; f < cellPhoneRules[i].AreaCodes.length; f++){
                      
                      console.log(phoneNumber)
                    
                      if( phoneNumber[0] == cellPhoneRules[i].AreaCodes[f].OperatorNumber || parseInt("" + phoneNumber[0] + phoneNumber[1]) == cellPhoneRules[i].AreaCodes[f].OperatorNumber ){
                        if(phoneNumber.length == cellPhoneRules[i].AreaCodes[f].Length ){
                        
                        
                          //all ok
                          
                          var btnSubmit = $('.step__footer__continue-btn');
                        
                          $('#country_phone_validator').css("display", "none");
                          $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                          errIndicative = 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");
                        
                          break;
                        
                        }else{
                        
                          err = 2;
                          //inputPhone.val('+358');
                        
                        }

                      
                        
                      
                      
                      }else{
                      
                        err = 1;
                        //inputPhone.val('+358');
                        
                      
                      }
                    
                    
                    }
                    
                  
                  		break;
                  }
                
                
                
                }
                
                
              }else
              if(countryValue == 'EUA'){
                
                $('#span_warning_indicative').hide();
                if(phoneNumber[0] != "+" || phoneNumber[1] != "1"){

                    //erro de indicativo
                      errIndicative = 1;

                      inputPhone.val('+1');

                }

                phoneNumber = phoneNumber.slice(2);

                //ciclo de countries
                for(var i = 0; cellPhoneRules.length > 0; i++){
                  

                  //verifica caso exista o Country no objeto.
                  if(countryValue == cellPhoneRules[i].Country ){
                  
                    for(var f= 0 ; f < cellPhoneRules[i].AreaCodes.length; f++){
                      
                      console.log(phoneNumber)
                    
                      if( phoneNumber[0] == cellPhoneRules[i].AreaCodes[f].OperatorNumber || cellPhoneRules[i].AreaCodes[f].OperatorNumber == 000  || parseInt("" + phoneNumber[0] + phoneNumber[1]) == cellPhoneRules[i].AreaCodes[f].OperatorNumber || phoneNumber[0] == cellPhoneRules[i].AreaCodes[f].OperatorNumber == 000 ){
                        if(phoneNumber.length == cellPhoneRules[i].AreaCodes[f].Length ){
                        
                        
                          //all ok
                          
                          var btnSubmit = $('.step__footer__continue-btn');
                        
                          $('#country_phone_validator').css("display", "none");
                          $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                          errIndicative = 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");
                        
                          break;
                        
                        }else{
                        
                          err = 2;
                          //inputPhone.val('+358');
                        
                        }

                      
                        
                      
                      
                      }else{
                      
                        err = 1;
                        //inputPhone.val('+358');
                        
                      
                      }
                    
                    
                    }
                    
                  
                  		break;
                  }
                
                
                
                }
                
                
              }else
              if(countryValue == 'UAE'){
                
                $('#span_warning_indicative').hide();
                if(phoneNumber[0] != "+" || phoneNumber[1] != "9" || phoneNumber[2] != "7" || phoneNumber[3] != "1"){

                    //erro de indicativo
                      errIndicative = 1;

                      inputPhone.val('+971');

                }

                phoneNumber = phoneNumber.slice(4);

                //ciclo de countries
                for(var i = 0; cellPhoneRules.length > 0; i++){
                  

                  //verifica caso exista o Country no objeto.
                  if(countryValue == cellPhoneRules[i].Country ){
                  
                    for(var f= 0 ; f < cellPhoneRules[i].AreaCodes.length; f++){
                      
                      console.log(phoneNumber)
                    
                      if( phoneNumber[0] == cellPhoneRules[i].AreaCodes[f].OperatorNumber || parseInt("" + phoneNumber[0] + phoneNumber[1]) == cellPhoneRules[i].AreaCodes[f].OperatorNumber || phoneNumber[0] == cellPhoneRules[i].AreaCodes[f].OperatorNumber == 000 ){
                        if(phoneNumber.length == cellPhoneRules[i].AreaCodes[f].Length ){
                        
                        
                          //all ok
                          
                          var btnSubmit = $('.step__footer__continue-btn');
                        
                          $('#country_phone_validator').css("display", "none");
                          $('#country_phone_validator2').css("display", "none");
                          $('#country_phone_validator3').css("display", "none");
                          err = 0;
                          errIndicative = 0;
                          btnSubmit.attr("disabled", false);
                          btnSubmit.css("background-color", "#000000");
						  btnSubmit.css("opacity","1");
                        
                          break;
                        
                        }else{
                        
                          err = 2;
                          //inputPhone.val('+358');
                        
                        }

                      
                        
                      
                      
                      }else{
                      
                        err = 1;
                        //inputPhone.val('+358');
                        
                      
                      }
                    
                    
                    }
                    
                  
                  		break;
                  }
                
                
                
                }
                
                
              }
              else{
                	console.log("else checknum")
                	var countrySpain = $('#checkout_shipping_address_country').val();
                
                	if(countrySpain == "Spain"){
                      
                      var i;
                      for (i = 0; i < phoneNumber.length; i++) {
                        if (phoneNumber[i] == "-"){
                          //err
                          err=1;
                          break;
                        
                        }else if(phoneNumber[i+1] == "+"){
                        
                          //err
                          err=1;
                          break;
                        }else{
                          
                          if(phoneNumber[8] != undefined){
                              var btnSubmit = $('.step__footer__continue-btn');

                              $('#country_phone_validator').css("display", "none");
                              $('#country_phone_validator2').css("display", "none");
                            $('#country_phone_validator3').css("display", "none");
                            err = 0;
                              errIndicative = 0;
                            btnSubmit.attr("disabled", false);
                            btnSubmit.css("background-color", "#000000");
                            btnSubmit.css("opacity","1");

                        }else{
                              //erro
                            err = 2;
                          }
                        }
                      }
                      
                      
                    }else{
                    
                      var i;
                      for (i = 0; i < phoneNumber.length; i++) {
                        if (phoneNumber[i+1] == "+"){
                          //err
                          err=1;
                          break;
                        
                        }else{
                          
                          if(phoneNumber[8] != undefined){
                              var btnSubmit = $('.step__footer__continue-btn');

                           $('#country_phone_validator').css("display", "none");
                              $('#country_phone_validator2').css("display", "none");
                            $('#country_phone_validator3').css("display", "none");
                            err = 0;
                              errIndicative = 0;
                            btnSubmit.attr("disabled", false);
                            btnSubmit.css("background-color", "#000000");
                            btnSubmit.css("opacity","1");

                        }else{
                              //erro
                            err = 2;
                          }
                        }
                      }
                    
                    
                    } 
            }
      }
    }

        
    
  
  
    
    function showError (){
          var btnSubmit = $('.step__footer__continue-btn');
          var mensagem = "";
          var div = "";
      
          
      
  
           if(errIndicative == 1){
             
              if(checkout_lang == "www.giannikavanagh.pt"){
                  mensagem = 'O indicativo não pode ser eliminado';
              }else if(checkout_lang == "www.giannikavanagh.es"){
               mensagem = 'El codigo del país no puede borrarse';
              }else if(checkout_lang == "www.giannikavanagh.fr"){
               mensagem = "L'indicatif ne peut pas être supprimé";
              } else{
                mensagem = 'The indicative cannot be eliminated';
              }
             
             
                 div = '<div class="field field--optional" id="country_phone_validator" style="border-radius: 5px; margin-bottom: 10px; padding: 10px; border: 1px solid rgb(211, 0, 0); color: rgb(211, 0, 0); background-color: rgb(255, 234, 229);">'
              + mensagem +'</div>';
             
                 if($('#country_phone_validator').innerHTML == undefined  && $('#country_phone_validator')[0] == undefined){
                	 
                   console.log($('.section--shipping-address .section__header .section__title').length);

                   if($('.section--shipping-address .section__header .section__title').length == 0){
                   	 
                     console.log($("#checkout_shipping_address_phone").parent());
                     $(div).insertBefore($("#checkout_shipping_address_phone").parent());

                   }else{
                     
                     $(div).insertBefore('.section--shipping-address .section__header .section__title');
                     
                   }
                  	 $('#country_phone_validator2').css("display", "none");
  
                
              }else {
              
                  $('#country_phone_validator').css("display", "block");
              }
         
              btnSubmit.attr("disabled", true);
              btnSubmit.css("background-color", "gray");
               }else 
                 if (err == 2){
                
                   if(checkout_lang == "www.giannikavanagh.pt"){
                     mensagem = 'Comprimento do número de telefone não está correto';
                    }else if(checkout_lang == "www.giannikavanagh.es"){
                     mensagem = 'La longitud del número de teléfono no es correcta';
                    }else if(checkout_lang == "www.giannikavanagh.fr"){
                     mensagem = "La longueur du numéro de téléphone n'est pas correcte";
                    } else{
                     mensagem = 'The telephone number length is incorrect ';
                    }
                
                
  
                     div = '<div class="field field--optional" id="country_phone_validator2" style="border-radius: 5px; margin-bottom: 10px; padding: 10px; border: 1px solid rgb(211, 0, 0); color: rgb(211, 0, 0); background-color: rgb(255, 234, 229);">'
                     + mensagem +'</div>';
  
                   if($('#country_phone_validator2').innerHTML == undefined  && $('#country_phone_validator2')[0] == undefined){
  					   console.log("error");
                       $(div).insertBefore('.section--shipping-address .section__header .section__title');
                       $('#country_phone_validator').css("display", "none");
  
                   }else {
  
                       $('#country_phone_validator2').css("display", "block");
  
                   }
  
                  btnSubmit.attr("disabled", true);
                  btnSubmit.css("background-color", "gray");
                
              }else if(err == 1){
                
                      if(checkout_lang == "www.giannikavanagh.pt"){
                     mensagem = 'O número de telefone está incorrecto';
                    }else if(checkout_lang == "www.giannikavanagh.es"){
                     mensagem = 'El número del teléfono no es correcto';
                    }else if(checkout_lang == "www.giannikavanagh.fr"){
                     mensagem = "Le numéro de téléphone est incorrect";
                    } else{
                      mensagem = 'The telephone number is incorrect';
                    }
                
                    div = '<div class="field field--optional" id="country_phone_validator3" style="border-radius: 5px; margin-bottom: 10px; padding: 10px; border: 1px solid rgb(211, 0, 0); color: rgb(211, 0, 0); background-color: rgb(255, 234, 229);">'
                    + mensagem +'</div>';
  
                    if($('#country_phone_validator3').innerHTML == undefined  && $('#country_phone_validator3')[0] == undefined){
  
                        $(div).insertBefore('.section--shipping-address .section__header .section__title');
                        $('#country_phone_validator').css("display", "none");
  
  
                    }else {
  
                        $('#country_phone_validator3').css("display", "block");
  
                    }
  
                    btnSubmit.attr("disabled", true);
                    btnSubmit.css("background-color", "gray");
  
                    }
  
    }
    
      $('#checkout_shipping_address_phone').focusout(function(){
  
             showError();
    
        })
    
    
            var showErrs;
            var errsPhone;
  			var checkIndicative;

    
            function VerifyPhone(){
              	console.log("VerifyPhone");
                if($('#country_info')[0] == undefined){

                   var countryValue = $('#selectIndicative').val();


                }else{

                  var countryValue = $('#country_info')[0].innerText;

                }
                var phoneNumber = $('#checkout_shipping_address_phone').val().replace(/\s/g,'');
                var phone =  $('#checkout_shipping_address_phone');
                var completePhone = "";
            
            if(phoneNumber[0] != '+'){
                  if(CountryZone == 'Portugal'){
                    
                    completePhone= '+351'+ phoneNumber;
                    phone.val(completePhone);

                  }else 
                  if(CountryZone == 'Espanha' | CountryZone == 'Spain'){
                    
                    completePhone= '+34'+ phoneNumber;
                    phone.val(completePhone);
                    
  
                  }else 
                  if(CountryZone == 'França' | CountryZone == 'France'){
                    
                    completePhone= '+33'+ phoneNumber;
                    phone.val(completePhone);
                    
                  
                  }else 
                  if(CountryZone == 'Inglaterra' | CountryZone == 'United Kingdom'){
                    
                    completePhone= '+44'+ phoneNumber;
                    phone.val(completePhone);
  
                  }else 
                  if(CountryZone == 'Holanda' | CountryZone == 'Netherlands' ){
                    
                    completePhone= '+31'+ phoneNumber;
                    phone.val(completePhone);
                    
                  }else 
                  if(CountryZone == 'Alemanha'| CountryZone == 'Germany'){
                    
                    completePhone= '+49'+ phoneNumber;
                    phone.val(completePhone);
                  
                  }else 
                  if(CountryZone == 'Belgium'){
                    
                    completePhone= '+32'+ phoneNumber;
                    phone.val(completePhone);
                  
                  }else
                  if(CountryZone == 'Canada'){
                    
                    completePhone= '+1'+ phoneNumber;
                    phone.val(completePhone);
                  
                  }else 
                  if(CountryZone == 'Cyprus'){
                    
                    completePhone= '+357'+ phoneNumber;
                    phone.val(completePhone);
                  
                  }else 
                  if(CountryZone == 'Denmark'){
                    
                    completePhone= '+45'+ phoneNumber;
                    phone.val(completePhone);
                  
                  }else 
                  if(CountryZone == 'Finland'){
                    
                    completePhone= '+358'+ phoneNumber;
                    phone.val(completePhone);
                  
                  }else 
                  if(CountryZone == 'Greece'){
                    
                    completePhone= '+30'+ phoneNumber;
                    phone.val(completePhone);
                  
                  }else 
                  if(CountryZone == 'Ireland'){
                    
                    completePhone= '+353'+ phoneNumber;
                    phone.val(completePhone);
                  
                  }else 
                  if(CountryZone == 'Italy'){
                    
                    completePhone= '+39'+ phoneNumber;
                    phone.val(completePhone);
                  
                  }else 
                  if(CountryZone == 'Luxembourg'){
                    
                    completePhone= '+352'+ phoneNumber;
                    phone.val(completePhone);
                  
                  }else 
                  if(CountryZone == 'Norway'){
                    
                    completePhone= '+47'+ phoneNumber;
                    phone.val(completePhone);
                  
                  }else 
                  if(CountryZone == 'Sweden'){
                    
                    completePhone= '+46'+ phoneNumber;
                    phone.val(completePhone);
                  
                  }else 
                  if(CountryZone == 'Switzerland'){
                    
                    completePhone= '+41'+ phoneNumber;
                    phone.val(completePhone);
                  
                  }else 
                  if(CountryZone == 'EUA'){
                    
                    completePhone= '+1'+ phoneNumber;
                    phone.val(completePhone);
                  
                  }else 
                  if(CountryZone == 'UAE'){
                    
                    completePhone= '+971'+ phoneNumber;
                    phone.val(completePhone);
                  
                  }
              	  else{
                    
                    completePhone = "+" + phoneNumber;
                    phone.val(completePhone);
                  }
  
            

            
            }
              
            InputChangeListener();
  
            showError();
          }
    
    
    
             $('#checkout_shipping_address_phone').focus(function() {
      
             checkIndicative= setInterval(VerifyPhone, 100); 
             
             errsPhone = setInterval(InputChangeListener, 200);
      
             showErrs = setInterval(showError, 200);
              
            });
    
          $('#checkout_shipping_address_phone').focusout(function() {
            	 
                 clearTimeout(checkIndicative);
  
                 clearTimeout(errsPhone);
  
                 clearTimeout(showErrs);
  
          });
        
  
            function addressIndicative(img, indicative,countryIndicative){
          
            var country = $('.listCountryIndicative li');
          var item  = '<img src="'+ img + '"> <div class="field__caret shown-if-js"> <svg class="icon-svg icon-svg--color-adaptive-lighter icon-svg--size-10 field__caret-svg" aria-hidden="true" focusable="false"> <use xlink:href="#caret-down"></use> </svg> <span id="country_info" style="display:none;">'+ countryIndicative +'</span>  </div>';
          var phone = $('#checkout_shipping_address_phone');
          
          $('#selectIndicative').html(item);
          
        
        }
          /*------------------ onload ------------------ */
  
        
    
            $('#checkout_shipping_address_id').change(function() {
      
            setTimeout(function(){
             var SelIndicative = $('#checkout_shipping_address_country');
            
            
               if (SelIndicative.val() =="Portugal"){
                 addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/33/assets/ly-icon-21213.png?v=1575974736','+351', 'Portugal');
               } else if (SelIndicative.val() =="Spain"){
                 addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/33/assets/ly-icon-21214.png?v=1575974736','+34', 'Espanha'); 
               } else if (SelIndicative.val() =="France"){
                 addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/33/assets/ly-icon-21215.png?v=1575974737','+33', 'França');
               }else if (SelIndicative.val() =="Canada"){
                 addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/37/assets/canada.jpg?v=1584112921','+1', 'Canada');
               }else if (SelIndicative.val() =="Belgium"){
                 addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/37/assets/belgica.jpg?v=1584112721','+32', 'Belgium');
               }else if (SelIndicative.val() =="Cyprus"){
                 addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/37/assets/chipre.jpg?v=1584112926','+357', 'Cyprus');
               }else if (SelIndicative.val() =="Denmark"){
                 addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/37/assets/dinamarca.jpg?v=1584112932','+45', 'Denmark');
               }else if (SelIndicative.val() =="Finland"){
                 addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/37/assets/filandia.jpg?v=1584112932','+358', 'Finland');
               }else if (SelIndicative.val() =="Greece"){
                 addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/37/assets/grecia.jpg?v=1584112949','+30', 'Greece');
               }else if (SelIndicative.val() =="Ireland"){
                 addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/37/assets/irlanda.jpg?v=1584112949','+30', 'Ireland');
               }else if (SelIndicative.val() =="Italy"){
                 addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/37/assets/italia.jpg?v=1584112949','+30', 'Italy');
               }else if (SelIndicative.val() =="Luxembourg"){
                 addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/37/assets/italia.jpg?v=1584112949','+30', 'Luxembourg');
               } else {
                 addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/33/assets/ly-icon-21212.png?v=1575974735','+44', 'Inglaterra');
               }	
            
            }, 400);
            
            setTimeout(function(){
                if($(".section--shipping-address").length > 0){
              var phoneNumber = $('#checkout_shipping_address_phone').val().replace(/\s/g,'');
            
                if(phoneNumber[0] != '+'){
                  
                 
                      VerifyPhone();
                 
                    
                }else{
  
                      InputChangeListener();
  
                      showError();
  
                }
               }
             }, 700);
  
          }); 
    
        if($(".section--shipping-address").length > 0){
          var phoneNumber = $('#checkout_shipping_address_phone').val().replace(/\s/g,'');
        }
  
          
  
  
  		if($('#address_form_new').length >0){

          var CountryZone = $('#selectIndicative').val();
          var phoneNumber = $('#checkout_shipping_address_phone').val().replace(/\s/g,'');
          var phone =  $('#checkout_shipping_address_phone');
          var completePhone = "";
          
          
           		if(CountryZone == 'Portugal'){
                    
                    phone.val('+351');

                  }else if(CountryZone == 'Espanha' | CountryZone == 'Spain'){
                    
                    completePhone= '+34';
                    phone.val(completePhone);
                    
  
                  }else if(CountryZone == 'França' | CountryZone == 'France'){
                    
                    completePhone= '+33';
                    phone.val(completePhone);
                    
                  
                  }else if(CountryZone == 'Inglaterra' | CountryZone == 'United Kingdom'){
                    
                    completePhone= '+44';
                    phone.val(completePhone);
  
                  }else if(CountryZone == 'Holanda' | CountryZone == 'Netherlands' ){
                    
                    completePhone= '+31';
                    phone.val(completePhone);
                    
                  }else if(CountryZone == 'Alemanha'| CountryZone == 'Germany'){
                    
                    completePhone= '+49';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Belgium'){
                    
                    completePhone= '+32';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Canada'){
                    
                    completePhone= '+1';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Cyprus'){
                    
                    completePhone= '+357';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Denmark'){
                    
                    completePhone= '+45';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Finland'){
                    
                    completePhone= '+358';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Greece'){
                    
                    completePhone= '+30';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Ireland'){
                    
                    completePhone= '+353';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Italy'){
                    
                    completePhone= '+39';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Luxembourg'){
                    
                    completePhone= '+352';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Norway'){
                    
                    completePhone= '+47';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Sweden'){
                    
                    completePhone= '+46';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Switzerland'){
                    
                    completePhone= '+41';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'EUA'){
                    
                    completePhone= '+1';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'UAE'){
                    
                    completePhone= '+971';
                    phone.val(completePhone);
                  
                  }else{
                    
                    completePhone = "+";
                    phone.val(completePhone);
                  }
  
          
          
          	VerifyPhone();


        }else{

          if($(".section--shipping-address").length > 0){
              if(phoneNumber[0] != '+'){

                  //console.log(" teste func inicio")
                  VerifyPhone();

              }else{

                InputChangeListener();

                showError();
              }

            }
        }
    
        $('#checkout_shipping_address_phone').change(function(){
            
              
           setTimeout(function(){ 
              var phoneNumber = $('#checkout_shipping_address_phone').val().replace(/\s/g,'');
            
                if(phoneNumber[0] != '+'){
                  
                 
                      VerifyPhone();
                 
                    
                }else{
  
                      InputChangeListener();
  
                        showError();
  
                }
              
             }, 700);
  
    
        })
        
        
 		$('#checkout_email').change(function(){

          setTimeout(function(){
              var phoneNumberChange = $('#checkout_shipping_address_phone').val().replace(/\s/g,'');
              console.log("phone change email " + phoneNumberChange);
          
                if(phoneNumberChange[0] != '+'){
                  
                   var SelIndicative = $('#checkout_shipping_address_country');
            
            
                     if (SelIndicative.val() =="Portugal"){
                       addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/33/assets/ly-icon-21213.png?v=1575974736','+351', 'Portugal');
                     } else if (SelIndicative.val() =="Spain"){
                       addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/33/assets/ly-icon-21214.png?v=1575974736','+34', 'Espanha'); 
                     } else if (SelIndicative.val() =="France"){
                       addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/33/assets/ly-icon-21215.png?v=1575974737','+33', 'França');
                     } else {
                       addressIndicative('https://cdn.shopify.com/s/files/1/1488/0202/t/33/assets/ly-icon-21212.png?v=1575974735','+44', 'Inglaterra');
                     }	

                      VerifyPhone();
                 
                    
                }else{
                      //InputChangeListener();
  
                      //showError();
  
                }
          },500);
          
        });
        

        $("#address_form_new #selectIndicative").change(function(){
          console.log("VerifyPhone");
          var CountryZone = $('#selectIndicative').val();
          var phoneNumber = $('#checkout_shipping_address_phone').val().replace(/\s/g,'');
          var phone =  $('#checkout_shipping_address_phone');
          var completePhone = "";
          
          	console.log("#address_form_new #selectIndicative ---->change");
          
          
           		if(CountryZone == 'Portugal'){
                    
                    phone.val('+351');

                  }else if(CountryZone == 'Espanha' | CountryZone == 'Spain'){
                    
                    completePhone= '+34';
                    phone.val(completePhone);
                    
  
                  }else if(CountryZone == 'França' | CountryZone == 'France'){
                    
                    completePhone= '+33';
                    phone.val(completePhone);
                    
                  
                  }else if(CountryZone == 'Inglaterra' | CountryZone == 'United Kingdom'){
                    
                    completePhone= '+44';
                    phone.val(completePhone);
  
                  }else if(CountryZone == 'Holanda' | CountryZone == 'Netherlands' ){
                    
                    completePhone= '+31';
                    phone.val(completePhone);
                    
                  }else if(CountryZone == 'Alemanha'| CountryZone == 'Germany'){
                    
                    completePhone= '+49';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Denmark'){
                    
                    completePhone= '+45';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Finland'){
                    
                    completePhone= '+358';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Greece'){
                    
                    completePhone= '+30';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Ireland'){
                    
                    completePhone= '+353';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Italy'){
                    
                    completePhone= '+39';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Luxembourg'){
                    
                    completePhone= '+352';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Norway'){
                    
                    completePhone= '+47';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Sweden'){
                    
                    completePhone= '+46';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'Switzerland'){
                    
                    completePhone= '+41';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'EUA'){
                    
                    completePhone= '+1';
                    phone.val(completePhone);
                  
                  }else if(CountryZone == 'UAE'){
                    
                    completePhone= '+971';
                    phone.val(completePhone);
                  
                  }else{
                    
                    completePhone = "+";
                    phone.val(completePhone);
                  }
  
          
          
          	VerifyPhone();

        });
  
  
        $(".listCountryIndicative li ").click(function(){

          	console.log("check");
			VerifyPhone();

        })
        
        
		$('#country_phone_validator').css("display", "none");
        $('#country_phone_validator2').css("display", "none");
        $('#country_phone_validator3').css("display", "none");

 
  })
  
  